import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import CommonToast from "../../../components/_utils/CommonToast";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const getAllFieldForceRequest = createAsyncThunk(
  "getAllFieldForceRequest",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_item_count,
      lifecycle_status,
      owner_account_id,
      start_date,
      end_date,
      payment_method,
      field_force_account_id,
      entity_id,
      category,
      category_ids,
      category_id,
      category_name,
      category_value,
      category_label,
      requested_amount,
      approved_amount,
      labels,
      additional_data,
      approved_amount_less_than_requested_amount,
    } = values;
    try {
      const response = await axiosInstance.get(
        `${lifecycle_status === "require approval" ? `${baseUrl}/requests/field_force/actionable` : `${baseUrl}/requests/field_force`}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            "page_no": page_no ? page_no : undefined,
            "page_size": page_item_count,
            "lifecycle_status": lifecycle_status,
            "payment_method": payment_method,
            "owner_account_id": owner_account_id,
            "category_name": category_name,
            "category_value": category_value,
            "category_label": category_label,
            "start_date": start_date,
            "end_date": end_date,
            "field_force_account_id[]": field_force_account_id,
            "entity_id": entity_id,
            "category": category,
            "category_ids": category_ids,
            "category_id": category_id,
            "requested_amount": requested_amount,
            "approved_amount": approved_amount,
            "labels": labels,
            "additional_data": additional_data,
             "approved_amount_less_than_requested_amount": approved_amount_less_than_requested_amount,
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error?.base?.[0] ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";
      return rejectWithValue(errorMessage);
    }
  },
);

export const approveFieldForceRequest = createAsyncThunk(
  "approveFieldForceRequest",
  async (values, { rejectWithValue }) => {
    const { page_no, page_size, category, category_id, entityId, labels } =
      values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/requests/field_force/actionable`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no,
            page_size,
            category,
            category_id,
            entity_id: entityId,
            labels,
          },
        },
      );

      const apiData = response.data;

      return apiData;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const addFieldForceLabelRequest = createAsyncThunk(
  "addFieldForceLabelRequest",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/field_force/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();
      CommonToast({
        text: "Label assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabelsFieldForceRequest") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabelsFieldForceRequest", payload);

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const removeFieldForceLabelRequest = createAsyncThunk(
  "removeFieldForceLabelRequest",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/field_force/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      CommonToast({
        text: "Label unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,

        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const getSpecificFieldForceRequest = createAsyncThunk(
  "getSpecificFieldForceRequest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/requests/field_force/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("error", error);
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);

export const fieldForceRequestDeniedApproval = createAsyncThunk(
  "fieldForceRequestDeniedApproval",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      let data = {
        request_ids: id,
        rejection_reason: AccountIdData,
      };

      if (Array.isArray(id)) {
        data.request_ids = id;
      } else {
        data.request_ids = [id];
      }

      const response = await axiosInstance.put(
        `${baseUrl}/requests/field_force/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const fieldforcerequestTxnReject = createAsyncThunk(
  "fieldforcerequestTxnReject",
  async ({ request_ids, AccountIdData }, { rejectWithValue }) => {
    try {
      const data = {
        request_ids,
        rejection_reason: AccountIdData,
      };

      const response = await axiosInstance.put(
        `${baseUrl}/requests/field_force/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.data?.status === false || response.status >= 400) {
        return rejectWithValue(response.data);
      }
      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response ?? "An error occurred");
    }
  },
);

const fieldForceRequest = createSlice({
  name: "fieldForceRequest",
  initialState: {
    allFieldForceRequestTransactionsData: [],
    allFieldForceRequestTransactionsLoading: false,
    allFieldForceRequestTransactionsError: false,

    addLabelsFfReqLoading: false,
    addLabelsFfReqError: false,
    addLabelsFfReqData: [],

    removeLabelsFfReqLoading: false,
    removeLabelsFfReqError: false,
    removeLabelsFfReqData: [],

    fieldForceRequestApprovalData: null,
    fieldForceRequestApprovalLoading: false,
    fieldForceRequestApprovalError: false,

    fieldForceRequestDetailsData: null,
    fieldForceRequestDetailsLoading: false,
    fieldForceRequestDetailsError: false,

    requestTxnRejectLoading: false,
    requestTxnRejectError: null,
    requestTxnRejectData: [],

    fieldForceRequestMultiApprovalData: null,
    fieldForceRequestMultiApprovalLoading: false,
    fieldForceRequestMultiApprovalError: false,

    fieldForceRequestMultiDeniedApprovalData: null,
    fieldForceRequestMultiDeniedApprovalLoading: null,
    fieldForceRequestMultiDeniedApprovalError: false,

    totalCount: 0,
    summary: {},
    storedPage: 1,
    toggleFfReq: false,
    isApprovalStatusSelected: false,
  },
  reducers: {
    setToggleFfReq: (state, action) => {
      state.toggleFfReq = action.payload;
    },
    resetToggleFfReq: (state) => {
      state.toggleFfReq = false;
    },
    resetpage: (state) => {
      state.storedPage = 1;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    setIsApprovalStatusSelected(state, action) {
      state.isApprovalStatusSelected = action.payload;
    },
    clearrequestTxnError: (state) => {
      state.requestTxnRejectError = null;
    },
    resetFieldForceMultiApprovalError: (state) => {
      state.fieldForceRequestMultiApprovalError = false;
    },
    resetFieldForceMultiDeniedApprovalLoading: (state) => {
      state.fieldForceRequestMultiDeniedApprovalLoading = null;
    },
    resetFieldForceMultiDeniedApprovalData: (state) => {
      state.fieldForceRequestMultiDeniedApprovalError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllFieldForceRequest.pending, (state) => {
      state.allFieldForceRequestTransactionsLoading = true;
    });
    builder.addCase(getAllFieldForceRequest.fulfilled, (state, action) => {
      state.allFieldForceRequestTransactionsLoading = false;
      state.allFieldForceRequestTransactionsData = action.payload;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsFieldForceRequest",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
    });
    builder.addCase(getAllFieldForceRequest.rejected, (state, action) => {
      state.allFieldForceRequestTransactionsError = true;
      state.allFieldForceRequestTransactionsLoading = false;
    });

    builder
      .addCase(approveFieldForceRequest.pending, (state) => {
        state.fieldForceRequestApprovalLoading = true;
        state.fieldForceRequestApprovalError = null;
      })

      .addCase(approveFieldForceRequest.fulfilled, (state, action) => {
        const payload = action.payload;

        state.fieldForceRequestApprovalLoading = false;
        state.fieldForceRequestApprovalError = null;
        state.fieldForceRequestApprovalData = payload;
      })

      .addCase(approveFieldForceRequest.rejected, (state, action) => {
        state.fieldForceRequestApprovalLoading = false;
        state.fieldForceRequestApprovalError =
          action.payload?.error || action.payload?.message;

        state.fieldForceRequestApprovalData = null;
        state.totalCount = 0;
        state.summary = {};
        CommonToast({
          text: state.fieldForceRequestApprovalError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      });

    builder.addCase(addFieldForceLabelRequest.pending, (state, action) => {
      state.addLabelsFfReqLoading = true;
    });
    builder.addCase(addFieldForceLabelRequest.fulfilled, (state, action) => {
      state.addLabelsFfReqLoading = false;
      state.addLabelsFfReqData = action.payload;
    });
    builder.addCase(addFieldForceLabelRequest.rejected, (state, action) => {
      state.addLabelsFfReqLoading = false;
      state.addLabelsFfReqError = action.payload;
      state.addLabelsFfReqData = null;
    });

    builder.addCase(removeFieldForceLabelRequest.pending, (state, action) => {
      state.removeLabelsFfReqLoading = true;
    });
    builder.addCase(removeFieldForceLabelRequest.fulfilled, (state, action) => {
      state.removeLabelsFfReqLoading = false;
      state.removeLabelsFfReqData = action.payload;
    });
    builder.addCase(removeFieldForceLabelRequest.rejected, (state, action) => {
      state.removeLabelsFfReqLoading = false;
      state.removeLabelsFfReqError = action.payload;
      state.removeLabelsFfReqData = null;
    });

    builder
      .addCase(getSpecificFieldForceRequest.pending, (state) => {
        state.fieldForceRequestDetailsLoading = true;
        state.fieldForceRequestDetailsError = null;
      })

      .addCase(getSpecificFieldForceRequest.fulfilled, (state, action) => {
        const payload = action.payload;

        state.fieldForceRequestDetailsLoading = false;
        state.fieldForceRequestDetailsError = null;
        state.fieldForceRequestDetailsData = payload;
      })

      .addCase(getSpecificFieldForceRequest.rejected, (state, action) => {
        state.fieldForceRequestDetailsLoading = false;
        state.fieldForceRequestDetailsError =
          action.payload?.error || action.payload?.message;
        console.log(
          state.fieldForceRequestDetailsError,
          "fieldForceRequestDetailsError",
        );
        CommonToast({
          text: state.fieldForceRequestDetailsError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      });

    builder
      .addCase(fieldforcerequestTxnReject.pending, (state) => {
        state.requestTxnRejectLoading = true;
        state.requestTxnRejectError = null;
      })

      .addCase(fieldforcerequestTxnReject.fulfilled, (state, action) => {
        const payload = action.payload;

        state.requestTxnRejectLoading = false;
        state.requestTxnRejectError = null;
        state.requestTxnRejectData = payload;
      })

      .addCase(fieldforcerequestTxnReject.rejected, (state, action) => {
        state.requestTxnRejectLoading = false;
        state.requestTxnRejectError = action.payload;
      });

    
    builder.addCase(fieldForceRequestDeniedApproval.pending, (state) => {
      state.fieldForceRequestMultiDeniedApprovalLoading = true;
    });
    builder.addCase(
      fieldForceRequestDeniedApproval.fulfilled,
      (state, action) => {
        state.fieldForceRequestMultiDeniedApprovalLoading = false;
        state.fieldForceRequestMultiDeniedApprovalData = action.payload;
      },
    );
    builder.addCase(
      fieldForceRequestDeniedApproval.rejected,
      (state, action) => {
        if (action.payload?.errors?.base) {
          sessionStorage.setItem(
            "selectedDataError",
            JSON.stringify(action.payload.errors.base),
          );
        }
        state.fieldForceRequestMultiDeniedApprovalLoading = null;
        state.fieldForceRequestMultiDeniedApprovalError = true;
        state.fieldForceRequestMultiDeniedApprovalData = null;
      },
    );
  },
});

export const {
  setStoredPage,
  setToggleFfReq,
  resetToggleFfReq,
  resetPage,
  clearrequestTxnError,
  resetFieldForceMultiApprovalError,
  resetFieldForceMultiDeniedApprovalLoading,
  resetFieldForceMultiDeniedApprovalData,
} = fieldForceRequest.actions;

export default fieldForceRequest.reducer;
